import DiceAttribute, { DiceAttributeExport } from './diceAttribute';
import { Category } from '../character/allValues';
import { AttributeExportTypes } from './baseAttribute';

export interface WeapontExport extends DiceAttributeExport {
  isProtection: boolean;
}

export default class WeaponAttribute extends DiceAttribute {
  public isProtection = false;

  public constructor(name: string, isProtection: boolean = false) {
    super(name);
    this.isProtection = isProtection;
    if (this.isProtection) {
      this.abbreviation = this.generateAbbreviation(this.name + '-vw');
      this.name = name + ' VW';
    } else {
      this.name = name + ' AW';
    }
    this.category = Category.Weapon;
  }

  public export(): WeapontExport {
    return {
      type: AttributeExportTypes.Weapon,
      abbreviation: this.abbreviation,
      isProtection: this.isProtection,
      dice: this.numDice,
      modifier: this.numBonus,
      name: this.name,
    };
  }

  public getClone() {
    let name = this.name;
    if (this.isProtection) {
      name = name.replace(' VW', '');
    } else {
      name = name.replace(' AW', '');
    }
    const clone = new WeaponAttribute(name, this.isProtection);
    clone.numDice = this.numDice;
    clone.numBonus = this.numBonus;
    return clone;
  }
}
